/*
  Hem & vardag – designlyft 25 okt 2026.
  1. Sektioner som kommer in i bild avslöjas en gång (innehållet syns om skriptet aldrig körs).
  2. Kvällsvideon laddas först nära skärmen, spelar ljudlöst bara i bild och har en Pausa/Spela-knapp.
  Inget körs i temaredigeraren, och vid prefers-reduced-motion spelar videon aldrig av sig själv.
*/
(() => {
  const root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hasObserver = 'IntersectionObserver' in window;
  root.classList.add('hs-js');

  const revealTargets = document.querySelectorAll('[data-hs-reveal], [data-hs-stagger]');
  if (!hasObserver || reduceMotion.matches) {
    revealTargets.forEach((element) => element.classList.add('is-in'));
  } else {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    revealTargets.forEach((element) => revealObserver.observe(element));
  }

  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const narrow = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('[data-hs-video]').forEach((video) => {
    const toggle = video.closest('figure')?.querySelector('[data-hs-video-toggle]');
    let wantsPlay = !reduceMotion.matches && !saveData;
    let inView = false;

    const ensureSource = () => {
      if (video.getAttribute('src')) return;
      const source = narrow.matches ? video.dataset.srcSmall : video.dataset.srcLarge;
      if (source) video.setAttribute('src', source);
    };

    const syncLabel = () => {
      if (!toggle) return;
      const playing = !video.paused;
      toggle.textContent = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
      toggle.setAttribute('aria-pressed', String(playing));
    };

    const play = () => {
      ensureSource();
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => syncLabel());
    };

    video.addEventListener('play', syncLabel);
    video.addEventListener('pause', syncLabel);

    toggle?.addEventListener('click', () => {
      if (video.paused) {
        wantsPlay = true;
        play();
      } else {
        wantsPlay = false;
        video.pause();
      }
    });

    if (hasObserver) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            inView = entry.isIntersecting;
            if (inView && wantsPlay) play();
            if (!inView && !video.paused) video.pause();
          }
        },
        { rootMargin: '160px 0px', threshold: 0.2 }
      );
      videoObserver.observe(video);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !video.paused) video.pause();
      if (!document.hidden && inView && wantsPlay) play();
    });

    syncLabel();
  });
})();
